import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Palette } from "lucide-react";
import ColorPicker from "@/components/ColorPicker";

export const ColorsSection = ({ settings, onInputChange }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Palette className="w-5 h-5" />
        Couleurs du Site
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-6">
      <ColorPicker
        label="Couleur Primaire"
        description="Couleur principale du site (titres, liens, elements importants)"
        value={settings.color_primary}
        onChange={(value) => onInputChange("color_primary", value)}
      />
      <Separator />
      <ColorPicker
        label="Couleur Secondaire"
        description="Couleur secondaire pour les elements de support"
        value={settings.color_secondary}
        onChange={(value) => onInputChange("color_secondary", value)}
      />
      <Separator />
      <ColorPicker
        label="Couleur Accent (Boutons)"
        description="Couleur des boutons d'action (CTA)"
        value={settings.color_accent}
        onChange={(value) => onInputChange("color_accent", value)}
      />
      <div className="bg-muted/50 rounded-lg p-4 text-sm text-muted-foreground">
        <p className="font-medium mb-2">Conseil :</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Utilisez le color picker pour choisir visuellement</li>
          <li>Les couleurs sont en format HSL (Hue Saturation Lightness)</li>
          <li>Les changements s'appliquent immediatement apres sauvegarde</li>
          <li>Testez le contraste pour l'accessibilite</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);
